import { takeEvery, call, put } from 'redux-saga/effects';
import actionKey from '../utils/action-key';
import request from '../api-utils/request';
import { FETCH_CAREER_MATCHES } from './career';
import { showSnackbarAction } from './snackbar';
import { fetchProgramMatchesAction } from './programs';

const CHANGE_FAVORITE = 'career/CHANGE_FAVORITE';
const CHANGE_FAVORITE_PROGRAM = 'career/CHANGE_FAVORITE_PROGRAM';

export default (state = {}, action) => {
    switch (action.type) {
        case FETCH_CAREER_MATCHES:
            return {};
        case actionKey.success(FETCH_CAREER_MATCHES): {
            return action.payload.matches.reduce((acc, { occupationID, favorite }) => {
                acc[occupationID] = favorite;
                return acc;
            }, {});
        }
        case CHANGE_FAVORITE: {
            return {
                ...state,
                [action.occupationId]: !state[action.occupationId],
            };
        }
        default:
            return state;
    }
};

/**
 * REDUX ACTIONS
 */

export const changeFavoriteAction = ({ onetId, occupationId, userId, favorite, programsIds }) => ({
    type: CHANGE_FAVORITE,
    onetId,
    occupationId,
    userId,
    favorite,
    programsIds,
});

export const changeFavoriteProgramAction = ({ userId, favorite }) => ({
    type: CHANGE_FAVORITE_PROGRAM,
    userId,
    favorite,
});

export function* rootSaga() {
    yield [
        takeEvery(CHANGE_FAVORITE, changeFavorite),
        takeEvery(CHANGE_FAVORITE_PROGRAM, changeFavoriteProgram),
        takeEvery(actionKey.failure(CHANGE_FAVORITE), changeFavoriteError),
        takeEvery(actionKey.failure(CHANGE_FAVORITE_PROGRAM), changeFavoriteProgramError),
    ];
}

function* changeFavorite({ type, onetId, favorite, occupationId, userId, programsIds }) {
    yield put(fetchProgramMatchesAction(userId));
    yield call(request, {
        url: '/api/career/favorite',
        type,
        options: {
            body: {
                onetId,
                occupationId,
                userId,
                programsIds,
            },
            method: favorite ? 'POST' : 'DELETE',
        },
    });
}

function* changeFavoriteProgram({ type, favorite, customProgramsID_PK, userId }) {
    yield call(request, {
        url: 'api/program/favorite',
        type,
        options: {
            body: {
                customProgramsID_PK,
                userId,
            },
            method: favorite ? 'POST' : 'DELETE',
        },
    });
}

function* changeFavoriteError() {
    yield put(showSnackbarAction({
        message: 'Error saving favorite career, please refresh page',
        type: 'failure',
        timeout: 5000,
    }));
}

function* changeFavoriteProgramError() {
    yield put(showSnackbarAction({
        message: 'Error saving favorite program, please refresh page',
        type: 'failure',
        timeout: 5000,
    }));
}



// WEBPACK FOOTER //
// ./src/client/redux/favorite-careers.js